import React from 'react';
import SubscriptionsHelp from './SubscriptionsHelp';
import APIKeysHelp from './APIKeysHelp';
import LLMProvidersHelp from './LLMProvidersHelp';
import JudgeRubricsHelp from './JudgeRubricsHelp';
import NotificationsHelp from './NotificationsHelp';
import SDKHelp from './SDKHelp';

interface SettingsHelpProps {
  activeTab: string;
}

/**
 * Settings Help - Context-aware help content switcher
 */
const SettingsHelp: React.FC<SettingsHelpProps> = ({ activeTab }) => {
  switch (activeTab) {
    case 'subscriptions':
      return <SubscriptionsHelp />;
    case 'api-keys':
      return <APIKeysHelp />;
    case 'llm-providers':
      return <LLMProvidersHelp />;
    case 'judge-rubrics':
      return <JudgeRubricsHelp />;
    case 'notifications':
      return <NotificationsHelp />;
    case 'sdk':
      return <SDKHelp />;
    default:
      return <SubscriptionsHelp />;
  }
};

export default SettingsHelp;
